import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { Login } from "../Services/login-service";
import { Globals } from '../Models/UserProfile.model';

declare var $: any;
declare var swal: any;
@Component({
    moduleId: module.id,
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [CookieService]
})

export class LoginComponent implements OnInit {
    public version: string = environment.VERSION;
    message: boolean;
    email: string;
    password: string;
    isInvalid: boolean;
    public loading = false;
    superToken:any;
    constructor(private spinnerService: Ng4LoadingSpinnerService, private cookieService: CookieService, private router: Router, private login: Login, private token: Token, private appUserDetails: AppWideUser) {
        this.message = false;
        this.isInvalid = false;

    }

    test: Date = new Date();
    // checkFullPageBackgroundImage() {
    //     var $page = $('.full-page');
    //     var image_src = $page.data('image');

    //     if (image_src !== undefined) {
    //         var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
    //         $page.append(image_container);
    //     }
    // };

    SignIn(email, password) {
        // Globals.LoginUsrId = uid;
        // this.router.navigate(["layout"]);
        this.loading = true;

        this.login.SignIn(email, password,"op").subscribe(values => {
          //  console.log(values);
            if (values != null) {
                this.isInvalid = false;
                this.GenerateToken(values);
            }
            else {

                this.loading = false;
                this.isInvalid = true;
            }
        },
            error => {
                this.isInvalid = true;
                this.loading = false;
            });

    }

    showSwal(type) {
     if (type == 'success-message') {
            swal({
                type: "success",
                title: "Login Successful !",
                text: "Welcome to scrubup!",
                timer: 900,
                showConfirmButton: false
            }).catch(swal.noop);
        }
    }

    onRegisterSelect() {
        this.router.navigate(["register"]);
    }

    OnForgotPasswordLink() {
        this.router.navigate(["forgot-password"]);
    }

    GenerateToken(tokenDetail) {
        this.token.access_token = tokenDetail.access_token;
        this.cookieService.set('accessToken', this.token.access_token);
        this.token.userName = tokenDetail.userName;
        this.token.expires = tokenDetail.expires;
        this.token.expires_in = tokenDetail.expires_in;
        this.token.issued = tokenDetail.issued;
        this.token.token_type = tokenDetail.token_type;
       // this.superToken=this.token;
        this.cookieService.set('superToken', JSON.stringify(this.token));
        this.cookieService.set('sup-access-token', this.token.access_token);
        this.cookieService.set('Token', JSON.stringify(this.token));
        this.cookieService.set('access-token', this.token.access_token);
        this.cookieService.set("IsFirstTime", "true");

        this.UserDetails(this.token);
        this.loading = false;
    }

    UserDetails(token: any) {
        this.login.GetUserDetail(token.userName, token).subscribe(x => {
            if (x != null) {
                this.PopulateAndRouteToDashboard(x);
                if (this.appUserDetails.UserName != null && this.appUserDetails.UserName != undefined) {
                    if (this.appUserDetails.UserName.length > 0) {
                        this.showSwal('success-message');
                        Globals.ImpersonationValue = false;
                        if(this.appUserDetails.UserId != 1)
                        // this.router.navigate([""]);
                        this.router.navigate(["layout/user-speciality"]);
                        else
                        this.router.navigate(["layout/speciality"]);
                    }
                }
            }
            else {
                this.isInvalid = true;
            }
        });

    }

    submitOnEnter(event, email, password) {
        if (event.keyCode == 13) {
            this.SignIn(email, password);
        }
    }

    PopulateAndRouteToDashboard(userProfileData) {

        this.appUserDetails.Email = userProfileData.Email;
        this.appUserDetails.Roles = userProfileData.Roles;
        this.appUserDetails.UserName = userProfileData.UserName;
        this.appUserDetails.UserId = userProfileData.UserId;
        // Globals.LoginUsrId = userProfileData.UserId; // Globals.LoginUsrId to be removed

        this.cookieService.set('userId', this.appUserDetails.UserId.toString());
        this.cookieService.set('impersonation',"false");
        this.cookieService.set('AppWideUser', JSON.stringify(this.appUserDetails));
    }

    ngOnInit() {

        //this.checkFullPageBackgroundImage();

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700)
    }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/login/login.component.ts